// src/utils/webSocket.js

function ws(ws_protocol, ip, port, paramStr, param, handler, heartbeatTimeout, reconnInterval, binaryType) {
  let obj = {};
  obj.ip = ip;
  obj.port = port;
  obj.url = ws_protocol + '://' + ip + ':' + port;
  obj.binaryType = binaryType || 'arraybuffer';

  if (paramStr) {
    obj.url += '?' + paramStr;
    obj.reconnUrl = obj.url + "&";
  } else {
    obj.reconnUrl = obj.url + "?";
  }
  obj.reconnUrl += "tiows_reconnect=true";
  obj.param = param;

  obj.handler = handler;
  obj.heartbeatTimeout = heartbeatTimeout;
  obj.reconnInterval = reconnInterval;

  obj.lastInteractionTime = function () {
    if (arguments.length == 1) {
      obj.lastInteractionTimeValue = arguments[0];
    }
    return obj.lastInteractionTimeValue;
  };

  obj.heartbeatSendInterval = heartbeatTimeout / 2;

  obj.connect = function (isReconnect) {
    var _url = obj.url;
    if (isReconnect) {
      _url = obj.reconnUrl;
    }
    var ws = new WebSocket(_url);
    obj.ws = ws;

    ws.binaryType = obj.binaryType;
    var self = obj;
    ws.onopen = function (event) {
      self.handler.onopen.call(self.handler, event, ws);
      self.lastInteractionTime(new Date().getTime());

      self.pingIntervalId = setInterval(function () {
        self.ping(self);
      }, self.heartbeatSendInterval);
    };
    ws.onmessage = function (event) {
      self.handler.onmessage.call(self.handler, event, ws);
      self.lastInteractionTime(new Date().getTime());
    };
    ws.onclose = function (event) {
      clearInterval(self.pingIntervalId);

      try {
        self.handler.onclose.call(self.handler, event, ws);
      } catch (error) {}

      self.reconn(event);
    };
    ws.onerror = function (event) {
      self.handler.onerror.call(self.handler, event, ws);
    };

    return ws;
  };

  obj.reconn = function (event) {
    var self = obj;
    setTimeout(function () {
      var ws = self.connect(true);
      self.ws = ws;
    }, self.reconnInterval);
  };

  obj.ping = function () {
    var iv = new Date().getTime() - obj.lastInteractionTime();
    if ((obj.heartbeatSendInterval + iv) >= obj.heartbeatTimeout) {
      obj.handler.ping(obj.ws);
    }
  };

  obj.send = function(data){
    obj.ws.send(data);
  };

  return obj;
}

export default ws;
